import React, { Component } from 'react';

class Welcome extends Component {
    render(){
        return (
            <div>
                <div className="container welcome">
                    <div className="jumbotron">
                        <h1 className="display-4">Welcome to Molesey Photographic Club</h1>
                        <p className="lead">We are a small friendly club with an impressive history of fifty years. We welcome members of all abilities, those just starting in photography as well as those who are more experienced. Our mutual aim is the enjoyment and improvement of our photography and our varied programme supports this.</p>
                        <hr className="my-4" />
                        <p>
                            We meet at 8.00pm in the East Molesey Methodist Church,  East Molesey, KT8 9JU on the second and fourth Tuesday in each month from September until June. Prospective new members are warmly invited to join us for one or two meetings before making a commitment to join. Just come along and someone will be on hand to welcome you.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Welcome


// WEBPACK FOOTER //
// ./src/components/welcome.jsx